export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "today_contracts": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contrats aujourd'hui"])},
        "today_contracts_tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nombre de contrats vendus aujourd'hui."])},
        "premium": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primes"])},
        "premium_tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Montant total des primes TTC générées par les contrats."])},
        "resiliation_rate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Taux de résiliation"])},
        "resiliation_rate_tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pourcentage de contrats résiliés par rapport au total des contrats vendus pendant la période sélectionnée."])}
      },
      "en": {
        "today_contracts": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contracts today"])},
        "today_contracts_tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Number of contracts sold today."])},
        "premium": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Premium"])},
        "premium_tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total amount of premiums (incl. tax) generated by the contracts."])},
        "resiliation_rate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancellation rate"])},
        "resiliation_rate_tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Percentage of contracts cancelled relative to the total number of contracts sold during the selected period."])}
      }
    }
  })
}
